import Product from './product';

export default class Coupon {

    constructor(data) {
        //console.log('coupon constructor ', data);
        this._code = data.code;
        this._lineId = data.lineId;
        this._type = data.type;
        this._value = data.value;
        this._valueRaw = data.hasOwnProperty('valueRaw') && data.valueRaw ? data.valueRaw : 0;
        this._points = data.hasOwnProperty('points') && data.points ? data.points : 0;
        this._pointsRaw = data.hasOwnProperty('pointsRaw') && data.points ? data.points : 0;
        this._typeLabel = data.typeLabel;
        this._details = data.hasOwnProperty('details') && data.details ? data.details : null;
        this._canDelete = data.hasOwnProperty('canDelete') ? data.canDelete : null;

        this._offers = [];
        if(data.hasOwnProperty('offers') && data.offers){
            data.offers.forEach(product => {
                //console.log('product', product);
                this._offers.push(new Product(product));
            });
        }

        this._items = [];
        if(data.hasOwnProperty('items') && data.items){
            data.items.forEach(product => {
                //console.log('coupon constructor, product', product);
                this._items.push(new Product(product));
            });
        }
    }

    get code() {
        return this._code;
    }

    get items() {
        return this._items;
    }
    
    get offers() {
        return this._offers;
    }

    get lineId() {
        return this._lineId;
    }

    get type() {
        return this._type;
    }

    get value() {
        return this._value;
    }

    get valueRaw() {
        return this._valueRaw;
    }
  
    get points() {
        return this._points;
    }

    get pointsRaw() {
        return this._pointsRaw;
    }

    get typeLabel() {
        return this._typeLabel;
    }

    get details() {
        return this._details;
    }

    get canDelete() {
        return this._canDelete;
    }
}